import { module } from 'angular';
import cameraComponent from './camera.component';

export default module('app')
	.component('camera', cameraComponent)
	.name;
